import React, { useEffect, useState } from "react";
import { promoURL } from "../../App";
import { useGlobalContext } from "../data/GlobalContext";

export default function RollingCommission({ onClose }) {
	const [commission, setCommission] = useState("0");
	const { username } = useGlobalContext();

	// Determine if user is logged in by checking if username exists
	const isLoggedIn = Boolean(username);

	useEffect(() => {
		if (isLoggedIn) {
			fetch(promoURL, {
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
				},
				body: `cmd=getFGHCommission&u=${username}`,
			})
				.then((response) => response.json())
				.then((data) => {
					if (data?.comm) {
						setCommission(data.comm);
					} else {
						console.error("No commission data found.");
					}
				})
				.catch((error) => {
					console.error("Error fetching commission data:", error);
				});
		}
	}, [isLoggedIn, username]);

	if (!isLoggedIn) {
		return null;
	}

	return (
		<div className="rolling-comission-container">
			<div>
				<img
					src="/images/character/FGH-CHARACTER-ROLLING-COMMISSION.webp"
					alt="FGH Rolling Commission popup with mascots"
				/>
			</div>
			{/* <div className="rolling-comission--desc">
        <p>Rolling Commission</p>
      </div> */}

			<div className="rolling-comission--points">
				<p>₱{commission}</p>
			</div>
			<div className="rolling-comission--btn">
				<button onClick={onClose}>Close</button>
			</div>
		</div>
	);
}
